import {Component, Input} from '@angular/core';
import {IvyFaceComponent} from '../../ivy-face/ivy-face.component';
import {ChatMessage} from '../../../models/chat-message';

@Component({
  selector: 'app-text-card',
  standalone: true,
  imports: [
    IvyFaceComponent
  ],
  templateUrl: './text-card.component.html',
  styleUrl: './text-card.component.scss'
})
export class TextCardComponent {
  @Input()
  data: ChatMessage;

}
